import {dispatch as d3dispatch} from 'd3-dispatch';

var dispatch = d3dispatch(
	'regionBoundariesReady',
	'countryBoundariesReady',
	'hoveredCountryUpdate',
	'selectedCountryUpdate',
	'hoveredRegionUpdate',
	'dataReady'
);

var api = {
	dispatch: dispatch
};

export default api;




/** WEBPACK FOOTER **
 ** ./src/Dispatch/Dispatch.js
 **/